import React, { useState } from 'react'

import { Button, InputWithLabel, PageHeading, Switch } from '../../../../Components/Atoms'
import { useAppNavigate } from '../../../../Hooks'
import { AddressTable, BrandsTable, DeleteModalComponent, Layout, PaymentTable } from '../../../../Components/Organism'
import { BreadCrum, RichTextEditor, Tabs } from '../../../../Components/Molecules'

export const EditBrand = () => {
    const navigate = useAppNavigate()
    const [deleteModal, setDeleteModal] = useState(false)
    const [tab, setTab] = useState(1)

    const onSubmitForm = (e) => {
        e.preventDefault()
        const formData = new FormData(e.target)
        const data = Object.fromEntries(formData)
        console.log(data)
        // navigate('/dashboard')
    }

    const tabList = [
        {
            id: 1,
            name: 'Products',
            active: true
        },
        {
            id: 2,
            name: 'Addresses',
            active: false
        }
    ]

    return (
        <Layout>
            <div className='p-5 md:p-10 font-inter'>
                <DeleteModalComponent
                    onModalStatus={() => setDeleteModal(!deleteModal)}
                    modal={deleteModal}
                    type={'delete'}
                />

                <div className='py-1.5'>
                    <BreadCrum content={[
                        {
                            title: 'Customers',
                            url: 'shop/products/brands'
                        },
                        {
                            title: 'Bette Swaniawski', // replace customer name
                            url: 'shop/products/brands/1/edit'
                        },
                        {
                            title: 'Edit',
                            url: 'shop/products/brands/1/edit'
                        },

                    ]} />
                </div>
                <div className='flex items-center justify-between'>
                    <PageHeading title='Edit Bette Swaniawski' />
                    <Button
                        title={'Delete'}
                        type={'button'}
                        textSize={'text-xs md:text-sm  px-4'}
                        height={'h-9'}
                        background={'bg-red'}
                        color="text-white"
                        onButtonPressed={() => setDeleteModal(!deleteModal)}
                        border={false}
                    />
                </div>
                <form
                    onSubmit={onSubmitForm}
                    className='mt-5  '
                >
                    <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-4'>
                        <div className='md:col-span-2'>
                            <div
                                className=' grid md:grid-cols-2 gap-4 border border-gray-100  bg-white rounded-xl px-6 md:px-8 pt-6 pb-10'
                            >
                                <InputWithLabel
                                    title={'Name'}
                                    name="name"
                                    placeholder='Enter name'
                                    password={false}
                                    type={'text'}
                                    isRequired={true}
                                />
                                <InputWithLabel
                                    title={'Slug'}
                                    name="slug"
                                    placeholder='Enter slug'
                                    password={false}
                                    type={'text'}
                                    disabled={true}
                                    isRequired={false}
                                />
                                <div className='md:col-span-2'>
                                    <InputWithLabel
                                        title={'Website'}
                                        name="text"
                                        placeholder='Enter Website'
                                        password={false}
                                        type={'text'}
                                        isRequired={true}
                                    />
                                </div>
                                <div>
                                    <Switch title="Visible to Customers." />
                                </div>

                                <div className='md:col-span-2'>
                                    <RichTextEditor
                                        name="description"
                                        title="Description"
                                        isRequired={false}
                                    />
                                </div>

                            </div>
                        </div>
                        <div className='border space-y-4 border-gray-100  bg-white rounded-xl p-6'>
                            <div className='flexx flex-col space-y-2 text-xs lg:text-sm'>
                                <div className='font-medium'>
                                    Created at
                                </div>
                                <div>
                                    6 month ago
                                </div>
                            </div>
                            <div className='flexx flex-col space-y-2 text-xs lg:text-sm'>
                                <div className='font-medium'>
                                    Last modified at
                                </div>
                                <div>
                                    3 month ago
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className='flex items-center mt-5 space-x-2'>
                        <Button
                            title={'Save changes'}
                            type={'submit'}
                            textSize={'text-xs md:text-sm px-4'}
                            height={'h-8 md:h-10'}
                        />
                        <Button
                            title={'Cancel'}
                            type={'button'}
                            onButtonPressed={() => navigate('/shop/customers')}
                            textSize={'text-xs md:text-sm max-w-min px-4'}
                            height={'h-8 md:h-10'}
                            background={'bg-white'}
                            color="text-black"
                            border={true}

                        />
                    </div>

                </form>
                <div className='flex items-center justify-center mt-5'>
                    <Tabs list={tabList} tab={tab} setTab={setTab} />
                </div>
                {
                    tab == 1 ?
                        <BrandsTable /> :
                        <AddressTable />

                }


            </div>
        </Layout>
    )
}
